var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cc-status"},[_c('div',{staticClass:"type",style:(_vm.styleVar)}),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }